function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 6.66v10.08C0 17.436.604 18 1.35 18H5.4V5.4H1.35C.604 5.4 0 5.964 0 6.66zM18.283 6.429h-3.868c-.338 0-.507-.222-.564-.318-.057-.094-.172-.347-.008-.637l1.363-2.412c.3-.528.33-1.149.085-1.703-.245-.555-.728-.957-1.326-1.104L13.004.02c-.234-.057-.482.016-.645.194l-5.22 5.695C6.598 6.5 6.3 7.263 6.3 8.058v6.728C6.3 16.558 7.768 18 9.573 18h6.511c1.47 0 2.769-.973 3.157-2.365l1.397-6.298c.04-.175.062-.355.062-.534 0-1.31-1.085-2.374-2.417-2.374z",
  transform: "translate(2 3.5)"
}));

var SvgThumbsUpDark = function SvgThumbsUpDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUpDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbs-up-dark.236ae4bd.svg";
export { ForwardRef as ReactComponent };